import React, { useState, useEffect } from 'react';
import { fetchReports } from '../api/strapi';
import { Link } from 'react-router-dom';
import './ReportsSlider.css';

export default function ReportsSlider() {
  const [reports, setReports] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetchReports()
      .then(all => {
        // only show the ones marked as featured
        setReports(all.filter(r => r.featured));
      })
      .catch(err => console.error('Error loading reports for slider:', err));
  }, []);

  if (!reports.length) return null;

  return (
    <div className="reportsSlider">
      {/* top-left numbered nav */}
      <div className="sliderNav">
        {reports.map((_, i) => (
          <button
            key={i}
            className={`navButton${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Go to slide ${i + 1}`}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* slides viewport */}
      <div className="slidesContainer">
        <div
          className="slidesTrack"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {reports.map((rpt, i) => (
            <div
              key={rpt.id}
              className="slide"
              style={{ backgroundImage: `url(${rpt.coverUrl})` }}
              role="tabpanel"
              aria-hidden={i !== current}
            >
              <div className="slideContent">
                <h2>{rpt.headline}</h2>
                <p>{rpt.summary}</p>
                <Link to={`/reports/${rpt.slug}`} className="slideCTA">
                  Read Full Report
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
